// extracted by mini-css-extract-plugin
export default {"card":"notFound_card__6tgV8","txt":"notFound_txt__5h3oU","boxImg":"notFound_boxImg__XXdjH","img":"notFound_img__nXYbt","bodyTxt":"notFound_bodyTxt__xcXix"};